export const getFileExtension = (filename: string) => filename.split('.').pop();
